import { RiUserLine } from "react-icons/ri";
import Logo from "../../../components/logo/Logo";

import "./styles.styl";
import classNames from "classnames";
import ShopBannerController from "../../../components/banner/ShopBannerController";
import { useRef, useEffect, useState } from "react";

export const CartTop = (props) => {
  const shopHeaderRef = useRef();
  const {
    homePage,
    openSettingsOrTab,
    companyName,
    subscription,
    logoSmallUrl,
  } = props;

  const handleLogoClick = () => {
    let finalUrl = homePage;
    if (!finalUrl.startsWith("http://") && !finalUrl.startsWith("https://")) {
      finalUrl = "https://" + finalUrl;
    }
    window.open(finalUrl, "_blank");
  };

  const onSettingsTabOpen = () => {
    document.body.classList.add("settings-active");
    openSettingsOrTab();
    shopHeaderRef.current.scrollIntoView();
  };

  return (
    <div className="cartHeader__container" ref={shopHeaderRef}>
      <div className="cartHeader__top">
        <div className="cartHeader__row">
          <div className="cartHeader__top__bg" />
          <div className="cartHeader__subscription-home">
            <Logo
              logoSmallUrl={logoSmallUrl}
              className="cartHeader__logo"
              onClick={handleLogoClick}
            />
            <p
              className={classNames("cartHeader__company", {
                cartHeader__company_long: companyName.length > 10,
              })}
            >
              {companyName}
            </p>
          </div>
          <CartTopProfileSection
            openSettingsOrTab={onSettingsTabOpen}
            subscription={subscription}
          />
        </div>
        <ShopBannerController />
      </div>
    </div>
  );
};

export const CartTopProfileSection = ({ openSettingsOrTab, subscription }) => {
  const displayName = subscription?.customer?.display_customer;

  useEffect(() => {
    return () => {
      document.body.classList.remove("settings-active");
    };
  }, []);

  return (
    <div
      className={`cartHeader__welcome ${
        !displayName ? "cartHeader__login" : ""
      }`}
      onClick={() => openSettingsOrTab()}
    >
      <p
        className={`cartHeader__welcome_display_name ${
          !displayName ? "cartHeader__welcome_display_login" : ""
        }`}
      >
        {displayName || "Login"}
      </p>
      <RiUserLine size={25} className="cartHeader__profile_icon" />
    </div>
  );
};
